// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__iS3d0","cell":"ColumnAccessor_cell__250YE","firstCellAccent":"ColumnAccessor_firstCellAccent__26B_0"};